import { Typography } from '@mui/material';
import { Dispatch } from '@reduxjs/toolkit';
import { reversePaymentRequest } from 'lib/api/payments';
import WarningDeleteDialog from 'lib/common/WarningDeleteDialog';
import React from 'react';

interface ReverseConfirmationProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  source: string;
  sourceId: number;
  setUp: () => void | Promise<void>;
}

const ReverseConfirmation: React.FC<ReverseConfirmationProps> = ({
  open,
  setOpen,
  source: _source,
  sourceId,
  setUp,
}) => {
  const handleReverse = async (dispatch: Dispatch) => {
    return await reversePaymentRequest(dispatch, sourceId);
  };

  const handleSuccess = () => {
    void setUp();
  };

  return (
    <WarningDeleteDialog
      open={open}
      setOpen={setOpen}
      title="Confirmar Reversión de Solicitud de Pago"
      actionType="reverse"
      warningMessages={[
        'Los pagos ejecutados volverán a estado Pendiente',
        'Los documentos volverán a marcarse como no pagados',
        'Se eliminará la fecha de ejecución registrada',
      ]}
      deleteItem={handleReverse}
      onDeleteSuccess={handleSuccess}
      confirmationText="Confirmo que deseo reversar esta solicitud de pago"
      requireConfirmation={true}
      successMessage="Reversión completada exitosamente"
    >
      <Typography variant="body2" color="text.secondary">
        <strong>Solicitud ID:</strong> {sourceId}
      </Typography>
    </WarningDeleteDialog>
  );
};

export default ReverseConfirmation;
